import { CeresFeaturesConfig } from './interfaces/ceres-features-config.interface';

const FEATURES: CeresFeaturesConfig = {
    timeManagement: {
        enabled: true,
        timeSheets: true,
        transactionalTimeTracking: true,
        capacity: true,
        absences: true,
        workload: true,
        disableTimeSheetsOption: false
    },
    businessPartner: {
        enabled: true
    },
    sales: {
        enabled: true,
        businessOpportunities: true,
        salesActivities: true,
        salesFunnel: true,
        offers: true,
        offersV2: true
    },
    projects: {
        enabled: true,
        copyExistingProject: true,
        copyExistingProjectWithChildren: false,
        orcChecker: false,
        inheritance: true,
        groups: {
            enabled: true,
            statusReports: false,
            classification: false
        },
        charging: true,
        timesheetLock: false,
        chargingCopyProposalBillingValue: true,
        nrsView: true,
        preStaffing: false,
        projectValueInheritance: false,
        restrictTimesheetFavoritesToAssignedProjects: false,
        projectSharedCosts: false
    },
    reporting: {
        enabled: true,
        dataQuality: true,
        pulseDashboard: true,
        costReport: true,
        workingHoursReport: true,
        absenceReport: true,
        gmsReportingDemo: false,
        productivityReport: true
    },
    employees: {
        enabled: true,
        experiences: true,
        multiRole: true
    },
    faq: {
        enabled: true
    },
    ticketTool: {
        enabled: true
    },
    administration: {
        enabled: true,
        servicePackages: true,
        departments: true,
        serviceProducts: true,
        orgIds: true,
        experiences: true,
        juno: false,
        customerPspElements: false,
        globalNotifications: true
    },
    services: {
        enabled: true,
        documents: false
    },
    scheduling: {
        enabled: true,
        scheduler: true,
        analytics: false,
        unrestrictedAccess: true
    },
    global: {
        currencyConversion: true,
        darkMode: true,
        sharepoint: true
    },
    sharepointExport: {
        enabled: false
    },
    pocReminder: {
        enabled: true
    },
    projectConfirmation: {
        enabled: true
    },
    documentCategorization: {
        enabled: true
    }
};

export default FEATURES;
